<div class="container-margin">
  <h2>{{ translationService.getLegalDisclaimerText() }}</h2>
  <p>{{ translationService.getLegalDisclaimerFullText() }}</p>
</div>
